// Status wa_bot_schedules (reminder). Warna default by id untuk AntD Tag.
export const BOT_SCHEDULE_STATUS_COLOR = {
  1: "blue", // Baru
  2: "cyan", // Dikirim ke Antrian
  3: "green", // Terkirim
  4: "orange", // Ditunda
  5: "default", // Dibatalkan
};

// Label fallback per-locale bila status.name dari API kosong.
export const BOT_SCHEDULE_STATUS_LABEL = {
  1: { "id-ID": "Baru", "en-US": "New" },
  2: { "id-ID": "Dikirim ke Antrian", "en-US": "Dispatched" },
  3: { "id-ID": "Terkirim", "en-US": "Sent" },
  4: { "id-ID": "Ditunda", "en-US": "Deferred" },
  5: { "id-ID": "Dibatalkan", "en-US": "Cancelled" },
};

export const botScheduleStatusColor = (id) =>
  BOT_SCHEDULE_STATUS_COLOR[id] ?? "default";

export const botScheduleStatusLabel = (id, locale) => {
  const loc = locale === "en-US" ? "en-US" : "id-ID";
  return BOT_SCHEDULE_STATUS_LABEL[id]?.[loc] ?? "";
};
